import { useSportItemsCount, useSportUrlParams } from '@mwl/core-lib';
import { Checkbox } from '@/components/Checkbox/Checkbox';
import { Image } from '@/components/Image/Image';
import { internationalIcon } from '@/constants';
import type { FilterTypes } from '../FilterPopup/FilterPopup.types';
import type { FilterCheckboxProps } from './FilterCheckbox.types';
import styles from './FilterCheckbox.module.scss';
export const FilterCheckbox = <T extends FilterTypes,>({
  className,
  isActive,
  item,
  analytics,
  onClick,
  type
}: FilterCheckboxProps<T>) => {
  const {
    categoryId: queryCategoryId,
    stage,
    sportId: querySportId,
    championshipId: queryChampionshipId
  } = useSportUrlParams();
  const isOutrightInTotalEnabled = !!((querySportId || queryCategoryId || queryChampionshipId) && (!stage || stage !== 'OUTRIGHT'));
  const count = useSportItemsCount({
    linesCount: item.linesCount,
    stage,
    isOutrightInTotalEnabled
  });
  return <label key={item.id} className={cn(styles.root, className, {
    [styles.active]: isActive
  })} data-sentry-component="FilterCheckbox" data-sentry-source-file="FilterCheckbox.tsx">
      <div className={styles.content}>
        {type === 'category' && <div className={styles.image}>
            <Image src={'icon' in item && item.icon ? item.icon : internationalIcon} width={20} height={20} alt={item.title || 'filter'} />
          </div>}
        {'title' in item && <span className={styles.title}>{item.title}</span>}
        <span className={styles.counter}>({count})</span>
      </div>

      <Checkbox checked={isActive} onChange={onClick} analytics={analytics} data-sentry-element="Checkbox" data-sentry-source-file="FilterCheckbox.tsx" />
    </label>;
};